// 📁 store/useSearchLoadingStore.ts
import { create } from 'zustand';

interface SearchLoadingState {
  loading: boolean;
  setLoading: (value: boolean) => void;
}

export const useSearchLoadingStore = create<SearchLoadingState>((set) => ({
  loading: false,
  setLoading: (value) => set({ loading: value }),
}));
